const topics = [
  { name: '暑期档电影', heat: '186万', trend: 'up', color: 'bg-primary-100 text-primary-700 border-primary-200' },
  { name: '狂飙', heat: '152万', trend: 'up', color: 'bg-primary-100 text-primary-700 border-primary-200' },
  { name: '眼泪女王', heat: '138万', trend: 'hot', color: 'bg-accent-100 text-accent-700 border-accent-200' },
  { name: '悬疑剧推荐', heat: '121万', trend: 'up', color: 'bg-secondary-100 text-secondary-700 border-secondary-200' },
  { name: '国漫崛起', heat: '106万', trend: 'up', color: 'bg-accent-100 text-accent-700 border-accent-200' },
  { name: '庆余年第二季', heat: '98万', trend: 'up', color: 'bg-primary-100 text-primary-700 border-primary-200' },
  { name: '韩剧必看', heat: '85万', trend: 'up', color: 'bg-secondary-100 text-secondary-700 border-secondary-200' },
  { name: '科幻大片', heat: '79万', trend: 'new', color: 'bg-accent-100 text-accent-700 border-accent-200' },
  { name: '纪录片推荐', heat: '62万', trend: 'new', color: 'bg-primary-100 text-primary-700 border-primary-200' },
  { name: '动漫番剧', heat: '54万', trend: 'up', color: 'bg-secondary-100 text-secondary-700 border-secondary-200' },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950 mb-3">
            热门话题
          </h2>
          <p className="text-foreground-500 text-sm md:text-base">
            大家都在讨论的影视热门话题
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-3 max-w-4xl mx-auto">
          {topics.map((topic, i) => (
            <span
              key={i}
              className={`inline-flex items-center gap-2 px-4 py-2 rounded-full border text-sm font-medium cursor-pointer transition-all hover:scale-105 ${topic.color}`}
            >
              {topic.name}
              <span className="flex items-center gap-0.5 text-xs opacity-70">
                {topic.trend === 'hot' ? (
                  <i className="ri-fire-line"></i>
                ) : topic.trend === 'new' ? (
                  <i className="ri-sparkling-line"></i>
                ) : (
                  <i className="ri-arrow-up-line"></i>
                )}
                {topic.heat}
              </span>
            </span>
          ))}
        </div>
      </div>
    </section>
  );
}